import React, { FunctionComponent } from "react";
import styles from "./TextEmbed.module.scss";
import TextEmbedBlockProps from "./TextEmbedProps.interface";

import BackgroundMedia from "components/BackgroundMedia/BackgroundMedia";
import combineClasses from "helpers/combine-classes";
import DynamicHeading from "components/DynamicHeading/DynamicHeading";
import getWrapperClasses from "blocks/helpers/getWrapperClasses";
import Paragraph from "components/Paragraph/Paragraph";
import setInViewClasses from "blocks/hooks/setInViewClasses";
import useSplitBackground from "blocks/hooks/useSplitBackground";
import useWrapperStyles from "blocks/hooks/useWrapperStyles";

const TextEmbed: FunctionComponent<TextEmbedBlockProps> = (props): JSX.Element => {
    const wrapperClasses = getWrapperClasses(props.settings);
    const wrapperStyles = useWrapperStyles(props.settings);
    const { inViewElementRef, inViewClasses } = setInViewClasses(styles);

    const { splitClasses, splitStyles } = useSplitBackground(props);

    const headlineCaseClass = props.settings.headlineCase ? styles[`case_${props.settings.headlineCase}`] : undefined;

    return (
        <section className={combineClasses(styles.wrapper, inViewClasses, ...wrapperClasses)} style={{ ...wrapperStyles, ...splitStyles }} ref={inViewElementRef}>
            <div className={combineClasses(styles.container, ...splitClasses)}>

                <div className={styles.content}>
                    {/* Headline */}
                    {props.content.headline ? (
                        <DynamicHeading key={`head_${props.contentUdi}`} className={combineClasses(styles.headline, headlineCaseClass)} text={props.content.headline} headlineSize={props.settings.headlineSize} headlineWeight={props.settings.headlineWeight} />
                    ) : null}

                    {/* Text */}
                    {props.content.bodyText ? (
                        <Paragraph key={`para_${props.contentUdi}`} className={styles.text} innerHTML={props.content.bodyText} />
                    ) : null}
                </div>

                <div className={styles.embed}>
                    {props.content.iframeUrl ? (
                        <iframe className={styles.iframe} src={props.content.iframeUrl} title={props.content.title} frameBorder="0" scrolling="no" width="100%" height="1100"></iframe>
                    ) : null}
                </div>


            </div>
            {props.settings.backgroundMedia?.[0] && props.settings.backgroundMedia.length > 0 ? (
                <BackgroundMedia key={props.contentUdi} {...props.settings.backgroundMedia[0]} />
            ) : null}
        </section>
    );
};

export default TextEmbed;